import { render, staticRenderFns } from "./OrderAddItemForm.vue?vue&type=template&id=1877999d"
import script from "./OrderAddItemForm.vue?vue&type=script&lang=js"
export * from "./OrderAddItemForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports